// FinishConfiguration.js - Main entry point for Finish Configuration
// This component renders the tabbed interface for managing all finish-related data
import React, { useState } from 'react';
import { Box, Tabs, Tab } from '@mui/material';

// Import all tab components
import FrameInternalColorsTab from './FrameInternalColorsTab';
import FrameExternalColorsTab from './FrameExternalColorsTab';

const FinishConfiguration = () => {
  const [activeTab, setActiveTab] = useState(0);

  const tabs = [
    { label: 'Frame Internal Colors', component: <FrameInternalColorsTab /> },
    { label: 'Frame External Colors', component: <FrameExternalColorsTab /> },
  ];

  return (
    <Box sx={{ width: '100%' }}>
      <Tabs
        value={activeTab}
        onChange={(e, newValue) => setActiveTab(newValue)}
        sx={{ mb: 2 }}
        variant="scrollable"
        scrollButtons="auto"
      >
        {tabs.map((tab, index) => (
          <Tab key={index} label={tab.label} />
        ))}
      </Tabs>

      {tabs[activeTab]?.component}
    </Box>
  );
};

export default FinishConfiguration;
